import axios from "axios";

const AxiosInstance = (contentType = "application/json") => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 30000,
  });
  instance.defaults.headers.common["Content-Type"] = contentType;

  instance.defaults.headers.common["Authorization"] = localStorage.getItem(
    "token"
  )
    ? `Bearer ${localStorage.getItem("token")}`
    : null;

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        localStorage.clear();
        return (window.location.href = "/");
      }
      return Promise.reject(error);
    }
  );
  return instance;
};

export default AxiosInstance;
